import {
  API_ERROR_MAP,
  STRIPE_DECLINE_FALLBACK_MESSAGE,
  STRIPE_DECLINE_MESSAGE_GROUPS,
} from '../main/types'
import apiErrorToErrorMessage from './apiErrorToErrorMessage'
import getApiErrorKey from './getApiErrorKey'

// Every string we are willing to show a member. useStripeActions throws Errors
// whose message is already one of these, so those pass straight through.
const MEMBER_FACING_MESSAGES = new Set([
  ...Object.values(API_ERROR_MAP),
  ...STRIPE_DECLINE_MESSAGE_GROUPS.map(({ message }) => message),
  STRIPE_DECLINE_FALLBACK_MESSAGE,
])

// Errors reaching a payment form's onError arrive in several shapes, and most of
// their messages are internal:
//  + useStripeActions throws `new Error(getStripeErrorMessage(...))`, already
//    resolved for a member.
//  + lp-form wraps API rejections in a redux-form SubmissionError whose message
//    is the constant 'Submit Validation Failed' and whose real error key lives at
//    errors._error (see errorMessageFromFormErrors). The underlying HttpError's
//    message is equally unshowable ('400 - Bad Request').
//  + Anything else that can reject mid-submit, notably Auth0's 'Login required'
//    when a session expires while the form is open.
// So the error key wins, and a raw message is only trusted when we wrote it.
//
// This can't reuse handleSubmitFailWithFlashMessage: that takes redux-form's
// (errors, submitError) from onSubmitFail, but StripeAutoRenewalForm catches in
// handleFormSubmit and calls onError(rawError) directly, so the rejection never
// reaches redux-form's lifecycle. It also can't reuse getStripeErrorMessage,
// which resolves a plain Error to STRIPE_GENERIC_ERROR and would discard the
// message useStripeActions has already resolved.
const getPaymentSubmitErrorMessage = (error) => {
  const apiErrorKey = getApiErrorKey(error)
  if (apiErrorKey) return apiErrorToErrorMessage(apiErrorKey)
  if (MEMBER_FACING_MESSAGES.has(error?.message)) return error.message
  return API_ERROR_MAP.UNKNOWN_ERROR
}

export default getPaymentSubmitErrorMessage
